"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterAsync = void 0;
async function filterAsync(array, predicate) {
    const shouldKeep = await Promise.all(array.map(predicate));
    const result = [];
    for (let [i, v] of array.entries()) {
        if (shouldKeep[i]) {
            result.push(v);
        }
    }
    return result;
}
exports.filterAsync = filterAsync;
//# sourceMappingURL=arrayAsyncHelper.js.map